// About + Team data (facts from the source rebranded site)

export const ABOUT_STATS = [
  { v: '6', l: 'Patents' },
  { v: '15+', l: 'Deep-tech experts' },
  { v: '99.8%', l: 'Detection accuracy' },
  { v: '10+', l: 'Core IPs' },
];

export const FOUNDER_TRACK = ['Checko', 'Upjao', 'Tracksure', 'BovTag', 'BillionTests', 'MilkoChecko', 'Visotonics'];

export const TEAM = [
  {
    id: 'pranav-asthana',
    name: 'Pranav Asthana',
    role: 'CBO & Co-Founder',
    bio: 'Cofounded Checko, Upjao. 20+ research papers, 10+ patents. Ex-Intel, IIT Kanpur.',
    img: '/team/pranav.png',
    linkedin: 'https://www.linkedin.com/in/asthanapranav/',
  },
  {
    id: 'pramod-prasad',
    name: 'Pramod Prasad',
    role: 'CRO & Co-Founder',
    bio: '25+ years driving $150M+ sales motion at Cisco, Motorola, Ericsson, IIFTD.',
    img: '/team/pramod.png',
    linkedin: 'https://www.linkedin.com/in/pramodprasad/',
  },
  {
    id: 'ritu-mishra',
    name: 'Ritu Mishra',
    role: 'CPO & Co-Founder',
    bio: 'Cofounded Upjao. 7 years building deep tech products. Ex-researcher at NCFlexe, IIT Kanpur.',
    img: '/team/ritu.png',
    linkedin: 'https://www.linkedin.com/in/ritu-raman-mishra/',
  },
  {
    id: 'mohini-behera',
    name: 'Mohini Behera',
    role: 'CTO & Co-Founder',
    bio: 'Cofounded Upjao. Developed 10+ AI products for large enterprises. IIT Jodhpur, NIT Rourkela.',
    img: '/team/mohini.png',
    linkedin: 'https://www.linkedin.com/in/mohini-mohan-behera/',
  },
];

export const FAQ_CATEGORIES = [
  {
    id: 'general',
    name: 'General',
    heading: 'Everything about the platform.',
    items: [
      {
        q: 'What is Visotonics?',
        a: 'Visotonics is a computer-vision platform that reads container, gate, warehouse and factory footage from cameras you already have — no new hardware required.',
      },
      {
        q: 'How does it read damage automatically?',
        a: 'Vision models capture every face of the container from existing CCTV, then detect and segment defects by type (dent, crack, rust) with area in mm², location and confidence. Two checkpoints can then be diffed to attribute new damage.',
      },
      {
        q: 'Is Visotonics right for my terminal?',
        a: 'If you have working IP cameras at your gates, cranes or yard — yes. Live pilots have been run at ports, ICDs, CFSs and warehouses. Bring a feed and we’ll read it live.',
      },
      {
        q: 'What does deployment cost?',
        a: 'Deployment is scoped against your existing CCTV, feed count and use cases. We publish transparent per-checkpoint pricing after a short discovery call.',
      },
    ],
  },
  {
    id: 'build',
    name: 'Build',
    heading: 'Building on your infrastructure.',
    items: [
      {
        q: 'Do I need new cameras?',
        a: 'No. Visotonics reads standard RTSP / ONVIF feeds from the cameras you already own. If a checkpoint needs a better angle, we’ll flag it in the site survey.',
      },
      {
        q: 'Where does the compute run?',
        a: 'On-premise at the edge, in your VPC, or fully cloud — you decide. Air-gapped and sovereign deployments are supported.',
      },
      {
        q: 'How long does a pilot take?',
        a: 'A typical pilot goes from feed access to verified output in 4–14 days, depending on scope.',
      },
    ],
  },
  {
    id: 'promote',
    name: 'Promote',
    heading: 'Going from pilot to production.',
    items: [
      {
        q: 'How is accuracy validated?',
        a: 'Every deployment includes a benchmark set from your own site. Detection accuracy, precision and recall are reported per class before go-live.',
      },
      {
        q: 'Can we run on top of existing VMS / NVR?',
        a: 'Yes. The platform sits alongside your VMS — no rip-and-replace.',
      },
    ],
  },
  {
    id: 'manage',
    name: 'Manage',
    heading: 'Managing the platform day-to-day.',
    items: [
      {
        q: 'What kind of alerts can I receive?',
        a: 'Threshold-based email, webhook and dashboard alerts. Every alert carries the moment (clip) and the case (context) — not just a timestamp.',
      },
      {
        q: 'Who watches the false positives?',
        a: 'Nuisance filtering (tarp, shadow, rain, dust) is on by default. Any leaked false positives are triaged into a training loop — accuracy compounds over time.',
      },
    ],
  },
  {
    id: 'integrations',
    name: 'Integrations',
    heading: 'Working with your systems.',
    items: [
      {
        q: 'Does it integrate with our TOS / WMS / ERP?',
        a: 'Yes — REST APIs, webhooks and message queues (Kafka / RabbitMQ) out of the box. Custom connectors for legacy TOS/WMS are delivered as part of onboarding.',
      },
      {
        q: 'Can we push structured data (JSON / XML) to our system?',
        a: 'Every event — gate read, damage finding, count, dimension — can be pushed as JSON, XML or CSV to your endpoint of choice.',
      },
    ],
  },
  {
    id: 'legal',
    name: 'Legal',
    heading: 'Legal, security and data.',
    items: [
      {
        q: 'Where is the data stored?',
        a: 'Your data stays in your region. Deployment can be fully on-premise or in your VPC on any major cloud.',
      },
      {
        q: 'Are the models patented?',
        a: 'Yes. Container damage detection and multiple pipeline components are covered under six patents (issued / pending) and 10+ core IPs.',
      },
      {
        q: 'How is footage handled?',
        a: 'Footage never leaves your perimeter unless you choose cloud deployment. On-premise deployments write clips and metadata to your existing storage.',
      },
    ],
  },
];

export const BLOG_POSTS = [
  {
    slug: 'cargo-counting-verifiable-loading-bay',
    category: 'Engineering',
    title: 'A Verifiable Count, at Every Bay, Every Session',
    summary:
      'How camera-based cargo counting replaces manual tallies at the loading dock with an automatic count and a visual record for every session — closing the gap between what left the dock and what got recorded.',
    readTime: '4 min read',
    image: 'https://visotonics.com/assets/blog-cargo-counting-verifiable-loading-bay.jpg',
    fallback: 'https://images.pexels.com/photos/4481259/pexels-photo-4481259.jpeg',
    date: '2025-06-10',
    narrowImage: true,
    uncroppedImage: true,
    sections: [
      { hideSectionLabel: true, h: 'The Challenge', p: 'A logistics operator running multiple loading bays needed a way to verify cargo counts against dispatch records, but their existing process created recurring problems. There was no visual record of disputes — when a customer questioned a shipped quantity, there was no way to go back and check, only what someone on shift remembered. Manual tallies were prone to error, since busy bays and shifting camera coverage made it easy for counts to drift from what actually left the dock. And without a session-level record, the operator couldn\'t tell whether a mismatch happened at loading, in transit, or in reporting.' },
      { hideSectionLabel: true, h: 'The Solution', p: 'Visotonics was evaluated against global bidders through a structured proof-of-concept before being selected. The deployment brought several advantages the operator hadn\'t had before: no new hardware required, since VisoPercept was configured to run directly on the operator\'s existing dock cameras; automatic, per-session counting, with every loading and unloading movement counted as it happens rather than reconciled afterward; support across cargo types, with cartons, gunny bags, pallets, FIBC bags and drums all counted with the same setup; and a visual record tied to every count, with each session\'s footage retrievable on demand.' },
      { hideSectionLabel: true, h: 'Implementation Process', p: 'The rollout followed a straightforward path from a single bay to full coverage. It began with go-live on a single bay, where Visotonics was deployed on existing cameras and configured for the operator\'s specific cargo type and movement pattern, with typical setups going live within 48 hours. Counts were then validated against the operator\'s own manual checks to confirm accuracy under real operating conditions. Once validated, the deployment expanded to cover the operator\'s other loading bays on the same site.' },
      { hideSectionLabel: true, h: 'Results', p: 'The numbers backed up what the operator was seeing day to day: 100% counting accuracy under clear camera conditions, per VisoPercept\'s independent benchmark; live within 48 hours of deployment, with no new camera hardware installed; every loading and unloading session now with a matching visual record, retrievable on demand; and dispatch discrepancies that can be investigated against the actual session footage, not recollection.' },
      { hideSectionLabel: true, h: '', p: 'For an operator handling high-volume dispatch, the shift wasn\'t just automation — it was having something to point to when a count is questioned. What used to end in a disagreement now ends with a session anyone can go back and check.' },
    ],
  },
  {
    slug: 'container-damage-detection',
    category: 'Engineering',
    title: 'Container Damage Detection: Improving Visibility with AI',
    summary:
      'Containers develop dents, scratches, rust and other damage across loading, unloading and transit. Visotonics uses AI-powered computer vision to detect external damage automatically and build a reliable visual record — without slowing operations down for manual inspection.',
    readTime: '3 min read',
    image: 'https://visotonics.com/assets/blog-container-damage-detection.jpg',
    fallback: 'https://images.pexels.com/photos/28185415/pexels-photo-28185415.jpeg',
    date: '2025-05-14',
    sections: [
      { h: 'The problem', p: 'Damage records are still written by hand in most terminals. Surveyors walk a container, note dents on paper, and file the report hours or days later — when the container is already gone. Disputes drag on for weeks.' },
      { h: 'A camera-first record', p: 'Visotonics converts existing CCTV into a six-face damage record for every container. Type, dimension, location and mm² area are logged automatically at every checkpoint — gate in, crane on, crane off, gate out.' },
      { h: 'Checkpoint diffs', p: 'Because every checkpoint carries a full record, any new damage can be attributed between checkpoints in seconds — crane damage separated from road damage separated from yard damage.' },
      { h: 'What changes', p: 'A 48-hour survey becomes a 48-second scan. Reports are sent by email the moment a threshold is crossed. Disputes close in days, not weeks.' },
    ],
  },
  {
    slug: 'warehouse-loading-unloading',
    category: 'Engineering',
    title: 'Warehouse Loading & Unloading: Bringing Precision to Every Movement with AI',
    summary:
      'Portable trolley-mounted AI cameras eliminate blind spots at the dock, delivering accurate item counts and continuous monitoring for every vehicle, every item, every time.',
    readTime: '4 min read',
    image: 'https://visotonics.com/assets/blog-warehouse-loading-unloading.jpg',
    fallback: 'https://images.pexels.com/photos/34207359/pexels-photo-34207359.jpeg',
    date: '2025-04-22',
    sections: [
      { h: 'Dock blind spots', p: 'A dock camera fixed in one place will always miss something. A trolley-mounted camera moves with the operation — covering every angle of every pallet.' },
      { h: 'Detection without triggers', p: 'The system counts cartons, bags, drums and pallets without a barcode scan. Damage is inspected in the same pass.' },
      { h: 'Offline-first', p: 'Detection and alerting run on-board — zero internet is enough. Sessions sync when connectivity returns.' },
      { h: 'Result', p: 'Inventory shrinkage drops by up to 60% in early rollouts, with video proof attached to every session.' },
    ],
  },
  {
    slug: 'container-gate-automation',
    category: 'Engineering',
    title: 'Container Gate Automation: Smarter Entry and Exit with AI',
    summary:
      'Reading container IDs, ISO codes and trailer IDs automatically at the gate, while checking for dents, cracks, rust and other defects — in under a minute, on the cameras already in place.',
    readTime: '4 min read',
    image: 'https://visotonics.com/assets/blog-container-gate-automation.jpg',
    fallback: 'https://images.pexels.com/photos/14068258/pexels-photo-14068258.jpeg',
    date: '2025-03-09',
    sections: [
      { h: 'Read on the move', p: 'IDs are decoded on moving trucks, in night, rain, fog and dust. No stop-and-shoot required.' },
      { h: 'Every ID, one pass', p: 'Container, ISO, trailer and wagon numbers are read together with the seal and timestamp — pushed to your TOS as a single event.' },
      { h: '400,000 daily reads', p: 'The engine powers over 25 yards today, at read accuracy that beats leading vision APIs in our benchmarks.' },
    ],
  },
  {
    slug: 'container-yard-management',
    category: 'Engineering',
    title: 'Container Yard Management: Smarter Planning with AI-Powered Visibility',
    summary:
      'AI-powered tracking gives yard teams a real-time digital twin of container locations, cutting crane travel time and turning misplaced-container searches into a lookup.',
    readTime: '3 min read',
    image: 'https://visotonics.com/assets/blog-container-yard-management.jpg',
    fallback: 'https://images.pexels.com/photos/28185415/pexels-photo-28185415.jpeg',
    date: '2025-02-18',
    sections: [
      { h: 'From spreadsheet to twin', p: 'A one-time survey maps the yard once. Every move after that is written into the twin automatically.' },
      { h: 'Placement planning', p: 'Every inbound gets a recommended slot — chosen to minimise crane travel and departure time.' },
      { h: 'Ask, don’t search', p: 'Ask for a container by ID, get its precise bay in seconds.' },
    ],
  },
  {
    slug: 'document-processing',
    category: 'Engineering',
    title: 'AI-Powered Document Processing: Faster, Smarter Logistics Documentation',
    summary:
      'Bills of entry, invoices and shipping documents read automatically into structured digital data — reducing manual entry, cutting errors, and making records easier to search and verify.',
    readTime: '3 min read',
    image: 'https://visotonics.com/assets/blog-document-processing.jpg',
    fallback: 'https://images.unsplash.com/photo-1767112601499-1b78cfb31a62',
    date: '2025-01-27',
    sections: [
      { h: 'Where OCR fails', p: 'Generic OCR breaks on logistics documents — stamps, signatures, table rows and shipper blocks read together only when the model understands the layout.' },
      { h: 'Key-value + tables', p: 'Document Vision extracts shipper, consignee, port of loading, cargo description and full table rows as structured JSON.' },
      { h: 'Straight to your system', p: 'Extracted data is pushed to your ERP / TOS via API or webhook — no re-keying, no rework.' },
    ],
  },
];
